import { render, staticRenderFns } from "./customizationSpeakerCard.vue?vue&type=template&id=3c4188e6"
import script from "./customizationSpeakerCard.vue?vue&type=script&lang=js"
export * from "./customizationSpeakerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports